export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="mil-fw">
      <p className="mil-light-soft">© {year} All rights reserved.</p>
      <p className="mil-light-soft">Noor Muhammad</p>
    </footer>
  )
}
